import { getUserPriority } from "./UserService";
import {
  isScoreEnabled,
  isActivitiesEnabled,
  isCheckinEnabled,
  isMeetingEnabled,
  isEventEnabled,
  isCommunityServiceEnabled,
  isPassEnabled,
} from "./SchoolService";

export const getAdminMenuItems = (school, jwt) => {
  let items = [];

  items.push({
    text: "MAIN",
    id: "header-main",
    isHeader: true,
  });
  items.push({
    text: "Admin Home",
    id: "admin-home",
    path: "/admin/welcome",
  });
  items.push({
    text: "Teacher Home",
    id: "teacher-home",
    path: "/teacher/welcome",
  });
  // items.push({
  //   text: "Student Home",
  //   id: "student-home",
  //   path: "/student/welcome",
  // });

  items.push({
    text: "SCHOOL",
    id: "header-calendar",
    isHeader: true,
  });

  items.push({
    text: "Reports",
    id: "reports",
    path: "/faculty/reports",
  });
  return items;
};

export const getVolunteerMenuItems = (school, jwt, user) => {
  let items = [];

  items.push({
    text: "MAIN",
    id: "header-main",
    isHeader: true,
  });
  items.push({
    text: "Volunteer Home",
    id: "today",
    path: "/volunteer/welcome",
  });
  items.push({
    text: "REPORTS",
    id: "header-main",
    isHeader: true,
  });
  items.push({
    text: "Ops by Status",
    id: "ops-by-status",
    path: "/report/ops-by-status",
  });
  items.push({
    text: "Ops Hour Totals",
    id: "ops-by-hours",
    path: "/adm/comm-service/totals",
  });
  items.push({
    text: "Student Ops History",
    id: "ops-by-hours",
    path: "/adm/comm-service/history",
  });

  return items;
};

export const getFacultyMenuItems = (school, jwt, user) => {
  let items = [];

  items.push({
    text: "MAIN",
    id: "header-main",
    isHeader: true,
  });
  if (getUserPriority(jwt) === 800) {
    items.push({
      text: "Admin Home",
      id: "admin",
      path: "/admin/welcome",
    });
  }

  items.push({
    text: "Teacher Home",
    id: "today",
    path: "/teacher/welcome",
  });

  items.push({
    text: "Chat with Us",
    id: "chat",
    path: "/chat",
  });

  items.push({
    text: "Find Student",
    id: "find-student",
    path: "/student/find",
  });

  if (isActivitiesEnabled(school)) {
    items.push({
      text: "ACTIVITIES",
      id: "header-calendar",
      isHeader: true,
    });
    items.push({
      text: "My Activities",
      id: "my-activities",
      path: "/teacher/activity/manage",
    });
    items.push({
      text: "Recommend",
      id: "recommend",
      path: "/teacher/recommend",
    });

    if (user.allowEditCalendar === "Y") {
      items.push({
        text: "Bulk Change",
        id: "bulk-change",
        path: "/activity/bulk-change",
      });
      items.push({
        text: "Bulk Delete",
        id: "bulk-delete",
        path: "/teacher/bulk-delete",
      });
    }
    items.push({
      text: "CALENDAR",
      id: "header-calendar",
      isHeader: true,
    });
    items.push({
      text: "This Week",
      id: "this-week",
      path: "/teacher/this-week",
    });
    items.push({
      text: "Next Week",
      id: "next-week",
      path: "/teacher/next-week",
    });
    items.push({
      text: "My Calendar",
      id: "my-calendar",
      path: "/teacher/calendar",
    });

    if (isMeetingEnabled(school)) {
      items.push({
        id: "my-meetings",
        text: "My Meetings",
        path: "/faculty/meetings",
      });
    }

    if (isEventEnabled(school)) {
      items.push({
        id: "my-events",
        text: "My Events",
        path: "/faculty/events",
      });
    }

    items.push({
      text: "Daily Roster",
      id: "daily-roster",
      path: "/teacher/roster",
    });
  }

  if (isScoreEnabled(school)) {
    items.push({
      text: "SCORING",
      id: "header-scoring",
      isHeader: true,
    });
    items.push({
      text: "Add Scores",
      id: "add-scores",
      path: "/teacher/score/add",
    });
    items.push({
      text: "Manage Scores",
      id: "manage-scores",
      path: "/teacher/manage-scores",
    });
    items.push({
      text: "Score Reports",
      id: "score-reports",
      path: "/report/scores",
    });
    items.push({
      text: "My Score History",
      id: "score-history",
      path: "/teacher/score/history",
    });
    items.push({
      text: "Fulfillments",
      id: "fulfillments",
      path: "/faculty/score/fulfillment",
    });
  }

  if (isPassEnabled(school)) {
    items.push({
      text: "PASSES",
      id: "header-passes",
      isHeader: true,
    });
    items.push({
      text: "Student History",
      id: "student-pass-history",
      path: "/report/pass-by-student",
    });
    items.push({
      text: "My History",
      id: "my-pass-history",
      path: "/report/pass-by-teacher",
    });
  }

  items.push({
    text: "SCHOOL",
    id: "header-school",
    isHeader: true,
  });

  if (isCommunityServiceEnabled(school)) {
    items.push({
      text: "Community Service",
      id: "cs",
      path: "/adm/comm-service",
    });
  }

  items.push({
    text: "Reports",
    id: "reports",
    path: "/faculty/reports",
  });
  items.push({
    text: "Homeroom",
    id: "homeroom",
    path: "/report/homeroom-report",
  });
  items.push({
    text: "Student Lists",
    id: "student-lists",
    path: "/teacher/student-list",
  });

  items.push({
    text: "How-Tos",
    id: "videos",
    path: "/teacher/how-tos",
  });
  items.push({
    text: "About",
    id: "about",
    path: "/about",
  });

  return items;
};

export const getStudentMenuItems = (school) => {
  let items = [];

  items.push({
    text: "MAIN",
    id: "header-main",
    isHeader: true,
  });
  items.push({
    text: "Home",
    id: "home",
    path: "/student/welcome",
  });
  items.push({
    text: "Chat with Us",
    id: "chat",
    path: "/chat",
  });

  if (isCheckinEnabled(school)) {
    items.push({
      text: "CHECKINS",
      id: "header-main",
      isHeader: true,
    });
    items.push({
      text: "Check In History",
      id: "checkinhistory",
      path: "/student/checkin",
    });
    items.push({
      text: "Comment History",
      id: "commenthistory",
      path: "/student/comments",
    });
  }

  if (isActivitiesEnabled(school)) {
    items.push({
      text: "ACTIVITIES",
      id: "header-main",
      isHeader: true,
    });
    items.push({
      text: "Sign Up for Activities",
      id: "signup",
      path: "/student/signup",
    });
    items.push({
      text: "Activity History",
      id: "activity.history",
      path: "/student/activity/history",
    });
    items.push({
      text: "Search Activity",
      id: "activity.search",
      path: "/student/activity/search",
    });
    items.push({
      text: "Suggest Activity",
      id: "suggest",
      path: "/student/suggest",
    });
    items.push({
      text: "Scan QR Code",
      id: "qr.scan",
      path: "/qr/scan",
    });
  }

  // if (isPassEnabled()) {
  items.push({
    text: "PASSES",
    id: "header-main",
    isHeader: true,
  });
  items.push({
    text: "Request Pass",
    id: "student-request-pass",
    path: "/student/pass/request",
  });
  items.push({
    text: "Pass History",
    id: "student-pass-history",
    path: "/student/pass/history",
  });
  // }

  if (isScoreEnabled(school)) {
    items.push({
      text: "SCORES/TARDIES",
      id: "header-main",
      isHeader: true,
    });
    items.push({
      text: "Score/Tardy History",
      id: "student-scores",
      path: "/student/scores",
    });
  }

  items.push({
    text: "SCHOOL",
    id: "header-main",
    isHeader: true,
  });
  if (isCommunityServiceEnabled(school)) {
    items.push({
      text: "Community Service",
      id: "comm.service",
      path: "/student/service/history",
    });
  }
  items.push({
    text: "Messages",
    id: "messages",
    path: "/student/messages",
  });
  items.push({
    text: "How-Tos",
    id: "videos",
    path: "/student/how-tos",
  });
  items.push({
    text: "About",
    id: "about",
    path: "/about",
  });

  return items;
};
